import script from "./approval-section-card.vue?vue&type=script&lang=ts&setup=true"
export * from "./approval-section-card.vue?vue&type=script&lang=ts&setup=true"

import "./approval-section-card.vue?vue&type=style&index=0&id=2780cdc4&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2780cdc4"]])

export default __exports__